import * as React from 'react';
import { SVGProps } from 'react';
export const BoxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={41}
    fill="none"
    {...props}
  >
    <path
      stroke="#18191C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.666 13.641h26.667v18a2 2 0 0 1-2 2H8.666a2 2 0 0 1-2-2v-18Z"
    />
    <path
      stroke="#18191C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.333 6.975h13.333l6.667 6.667H6.666l6.667-6.667ZM13.334 20.308h6.667"
    />
  </svg>
);
